import { buildWhatsappLink } from "~/helpers/routing";

export default function useCommunication() {
  const { phone, companyAddress, telegram, whatsappBot } = useBranch();
  const { branchEmailAddress: supportEmail } = useRouting();
  const whatsapp = whatsappBot || phone;
  const whatsappLink = buildWhatsappLink(whatsapp.raw);
  const companyAddressText = companyAddress.text;

  return {
    phone, whatsapp, whatsappLink, telegram, supportEmail, companyAddressText
  };
}